import { db } from '../firebase';
import {
  collection, addDoc, onSnapshot,
  updateDoc, deleteDoc, doc, getDoc, query, orderBy,
} from 'firebase/firestore';

// ── Helpers ───────────────────────────────────────────────────────────────────

/** Attaches Firestore doc ID as _docId so the UI can use it for updates/deletes */
const withDocId = (snapshot) =>
  snapshot.docs.map((d) => ({ _docId: d.id, ...d.data() }));

// ── Service Requests ──────────────────────────────────────────────────────────

export const saveServiceRequest = (request) =>
  addDoc(collection(db, 'serviceRequests'), request);

export const subscribeServiceRequests = (callback) => {
  const q = query(collection(db, 'serviceRequests'), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => callback(withDocId(snap)));
};

export const updateServiceRequestStatus = (_docId, status) =>
  updateDoc(doc(db, 'serviceRequests', _docId), { status });

export const deleteServiceRequest = (_docId) =>
  deleteDoc(doc(db, 'serviceRequests', _docId));

// ── Orders ────────────────────────────────────────────────────────────────────

export const saveOrder = (order) =>
  addDoc(collection(db, 'orders'), order);

export const subscribeOrders = (callback) => {
  const q = query(collection(db, 'orders'), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => callback(withDocId(snap)));
};

export const updateOrderStatus = (_docId, status) =>
  updateDoc(doc(db, 'orders', _docId), { status });

export const deleteOrder = (_docId) =>
  deleteDoc(doc(db, 'orders', _docId));

// ── Product Requests ──────────────────────────────────────────────────────────

export const saveProductRequest = (request) =>
  addDoc(collection(db, 'productRequests'), request);

export const subscribeProductRequests = (callback) => {
  const q = query(collection(db, 'productRequests'), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => callback(withDocId(snap)));
};

export const updateProductRequest = (_docId, data) =>
  updateDoc(doc(db, 'productRequests', _docId), data);

export const getProductRequestById = async (_docId) => {
  const snap = await getDoc(doc(db, 'productRequests', _docId));
  if (!snap.exists()) return null;
  return { _docId: snap.id, ...snap.data() };
};

export const deleteProductRequest = (_docId) =>
  deleteDoc(doc(db, 'productRequests', _docId));
